module.exports = __webpack_public_path__ + "media/img/home/gallery/gallery9-fcc64bce33940c8d096475e00d786fc2.png";